import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import httpClient,{getBaseURL} from "utility/httpClient.util"


i18n
  .use(Backend) // Load translations using http backend
  .use(LanguageDetector) // Detect language automatically
  .use(initReactI18next) // Pass the i18n instance to react-i18next.
  .init({
    backend: {
        //loadPath: '/locales/{{ns}}/{{lng}}.json',
        loadPath: getBaseURL()+'/core/locales/{{ns}}/{{lng}}.json',
        // Override the request function
      request:  (options, url, payload, callback) =>{
        // Implement your custom request logic here
        // Example using fetch API
        const path = url.replace(getBaseURL(), '');
        httpClient.get(path).then((data)=>{
          callback(null, { status: 200,data:data.data }); 
        })
        .catch((error)=>{
          callback(error, { status: error.status || 500, statusText: error.message });
        })
        // fetch(url, {
        //   method: 'GET', // or 'POST' if payload needs to be sent
        //   credentials: 'include', // if credentials (cookies) need to be included in cross-origin requests
        //   headers: {
        //     // Custom headers
        //     'Content-Type': 'application/json',
        //     // Any other headers
        //   },
        //   // Include the payload if necessary
        //   body: payload ? JSON.stringify(payload) : null,
        // })
        //   .then(response => {
        //     if (!response.ok) throw new Error('Network response was not ok');
        //     return response.json(); // or response.text() if your response is text and not JSON
        //   })
        //   .then(data => {
        //     // Success callback                      
        //     callback(null, { status: 200,data:data }); // Pass the data and a status object to the callback
        //   })
        //   .catch(error => {
        //     // Error callback
        //     callback(error, { status: error.status || 500, statusText: error.message });
        //   });
      },
    },
    ns: ["common"], // default namespace, add more as needed
    defaultNS: "common",
    fallbackLng: "en", // Use English if detected lang is unavailable
    debug: false, //process.env.NODE_ENV == 'development', // Set to false in production
    interpolation: {
      escapeValue: false, // Not needed for React as it escapes by default
    },
  });

export default i18n;
